import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CookiesConsentService } from "src/app/core/cookiesConsentService/cookies-consent.service";
import { CookiesModalComponent } from "../cookies-modal/cookies-modal.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-cookies-banner",
  templateUrl: "./cookies-banner.component.html",
  styleUrls: ["./cookies-banner.component.scss"],
  imports: [TranslatePipe],
})
export class CookiesBannerComponent {
  constructor(
    public cookies: CookiesConsentService,
    private dialog: MatDialog,
  ) {
    console.log(cookies.showBanner);
  }

  accept() {
    this.cookies.acceptCookies();
  }

  reject() {
    this.cookies.rejectCookies();
  }
  openMoreDialog() {
    const dialogRef = this.dialog.open(CookiesModalComponent, {
      width: "650px",
      maxWidth: "95vw",
      panelClass: "cookies-dialog-panel",
      disableClose: true,
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log("Modal closed with:", result);

      if (result === "accept") {
        // Do something when user accepts
        this.accept();
      }

      if (result === "deny") {
        // Do something when user denies
        this.reject();
      }
    });
  }
}
